import { ConversationBillingSummary } from "../models/conversationBilling.model";
import { createAxiosClient } from "./http-client.service";

const billingApi = createAxiosClient(
  process.env.REACT_APP_PYTHON_BACKEND_URL || "http://localhost:8000/",
);

export async function getConversationBillingSummary(
  businessId: string,
  days: number,
): Promise<ConversationBillingSummary> {
  const response = await billingApi.get<ConversationBillingSummary>(
    `/api/conversation-billing/business/${encodeURIComponent(businessId)}/summary`,
    { params: { days } },
  );
  return response.data;
}
